import styled from "styled-components";
import { useData } from "../../context/GetDataContext";

import { useEffect, useState } from "react";
import { point, distance as turfDistance } from "@turf/turf";
import { getRouteDistance } from "../../utils/getDistance";

const LoadCount = () => {
  const { data } = useData();
  const [directions, setDirections] =
    useState<google.maps.DirectionsResult | null>(null);
  const [distanceKm, setDistanceKm] = useState<string | null>(null);
  const [distanceMiles, setDistanceMiles] = useState<string | null>(null);

  useEffect(() => {
    const origin = {
      lat: Number(data?.shipper?.lat),
      lng: Number(data?.shipper?.lng),
    };

    const destination = {
      lat: Number(data?.consignee?.lat),
      lng: Number(data?.consignee?.lng),
    };

    if (origin.lat && destination.lat) {
      getRouteDistance(origin, destination)
        .then(({ distanceKm, distanceMiles, directions }) => {
          setDirections(directions);
          setDistanceKm(distanceKm);
          setDistanceMiles(distanceMiles);
        })
        .catch(console.error);
    }
  }, [data]);

  return (
    <>
      <div className="mb-3">
        <strong>Load Id# {data?.id}</strong>
      </div>
      <Div className="border bg-gray-100 mb-3">
        <ul className="flex">
          <li className="text-green-600 flex-auto">
            <span className="text-gray-700">Rate</span> {data?.primary_fees}
          </li>
          <li className="text-green-600 flex-auto">
            <span className="text-gray-700">Flat Rate</span>{" "}
            {data?.primary_fees}
          </li>
          <li className="text-green-600 flex-auto">
            <span className="text-gray-700">Revenue</span> 0
          </li>
          <li className="text-green-600 flex-auto">
            <span className="text-gray-700">Loaded</span> 0
          </li>
          <li className="text-green-600 flex-auto">
            <span className="text-gray-700">Empty</span> 0
          </li>
          <li className="text-green-600 flex-auto">
            <span className="text-gray-700">Distance</span>{" "}
            {distanceMiles ? distanceMiles : 0} Miles
          </li>
          <li className="text-green-600 flex-auto">
            <span className="text-gray-700">Detention</span> 0
          </li>
          <li className="text-green-600 flex-auto">
            <span className="text-gray-700">Qty</span>{" "}
            {data?.pick_up_total_quantity}
          </li>
          <li className="text-green-600 flex-auto">
            <span className="text-gray-700">Weight</span>{" "}
            {data?.weight ? data?.weight : 0}{" "}
            <strong className="text-gray-700">lbs</strong>
          </li>
        </ul>
      </Div>
    </>
  );
};
export default LoadCount;

const Div = styled("div")`
  ul li {
    border-right: 1px solid #d7d7d7;
    padding: 10px 10px;
    font-size: 0.9rem;
  }
`;
